import type { FunctionComponent } from "preact";
import { useEffect } from "preact/hooks";
import { useParams, useLocation } from "wouter-preact";
import { HeaderNav } from "../../components/header_nav/header_nav.tsx";

/**
 * 重定向到PWA的指定页面
 * /r/<路径的URIComponent编码后的结果>?参数1=数值&参数2=数值……
 */
export const RedirectPage: FunctionComponent = (_) => {
    const pathParams = useParams();
    const [_location, setLocation] = useLocation();

    useEffect(() => {
        const target = decodeURIComponent(pathParams["loc"] ?? "%2F");
        const url = new URL(globalThis.location.href);
        const searchParams = url.searchParams;
        // convert searchParams to record
        const params = {} as Record<string, string>;
        searchParams.forEach((val, k) => {
            params[k] = val;
        });
        console.log("redirect:", target, params);
        url.search = "";
        globalThis.history.replaceState(params, "", url);
        setLocation(target, { replace: true, state: params });
    }, []);

    return (
        <div>
            <HeaderNav />
            <article aria-busy="true" class="container"></article>
        </div>
    );
};
export default RedirectPage;
